import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';

import {
  DEFAULT_COUNTRY_CODE,
  VALID_COUNTRY_CODES,
} from '@lib/constants/country-code';

/**
 * 驗證 URL 中的 countryCode 是否合法，分兩種情境處理：
 *
 * 1. **缺少 country code**（countryCode 不存在或長度不是 2）
 *    → 在原始路徑前面加上預設 country code（prepend）
 *    → 例如 /checkout → /tw/checkout
 *
 * 2. **無效的兩碼 country code**（長度為 2 但不在 VALID_COUNTRY_CODES 中）
 *    → 將無效的 country code 替換成預設值（replace）
 *    → 例如 /en/store → /tw/store
 */
const CountryCodeGuard = () => {
  const { countryCode } = useParams<{ countryCode: string }>();
  const location = useLocation();

  if (!countryCode || countryCode.length !== 2) {
    // 非兩碼 segment → 缺少 country code，prepend 預設值
    const redirectPath = `/${DEFAULT_COUNTRY_CODE}${location.pathname}${location.search}${location.hash}`;
    return <Navigate to={redirectPath} replace />;
  }

  if (!VALID_COUNTRY_CODES.has(countryCode)) {
    // 兩碼但無效 → 替換成預設 country code
    const rest = location.pathname.slice(countryCode.length + 1); // 移除 "/{cc}"
    const redirectPath = `/${DEFAULT_COUNTRY_CODE}${rest || '/'}${location.search}${location.hash}`;
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

export default CountryCodeGuard;
